import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/core/auth";
import { useThemeEffect } from "@/shared/hooks";
import { api } from "@/core/api/client";
import { setAgentHubTokenGetter } from "@/core/api/agentHubClient";
import { useAuth } from "@/core/auth/useAuth";
import { router } from "@/core/router";
import { useEffect } from "react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

/** Wire both API clients' token getter/refresher to the auth context */
function ApiWiring() {
  const { getAccessToken, refreshToken } = useAuth();

  useEffect(() => {
    // Local hand-rolled client (used by /chat dispatch+poll and hooks.ts)
    api.setTokenGetter(getAccessToken);
    api.setTokenRefresher(refreshToken);
    // Shared AgentHubClient (used by feature api.ts files for callTool)
    setAgentHubTokenGetter(getAccessToken);
  }, [getAccessToken, refreshToken]);

  return null;
}

function ThemeWiring() {
  useThemeEffect();
  return null;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ApiWiring />
        <ThemeWiring />
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  );
}
